import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Banner } from 'src/app/models';
import { ContentImagePipe } from '../../../pipes/cms-image.pipe';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-full-banner',
  templateUrl: './full-banner.component.html',
  styleUrls: ['./full-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOptimizedImage],
})
export class FullBannerComponent {
  @Input() content: Partial<Banner>;
  @Input() isMobile: boolean;

  imageError() {
    this.content.image = '';
  }
}
